import Button from '../Button/Button';
import { ButtonMode } from '../Button/button-mode.enum';
import React from 'react';
import { useTranslationByKey } from 'src/hooks/use-translation-by-key';

const NoProjectsAvailablePage: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  const t = useTranslationByKey('PAGES.NO_PROJECTS_AVAILABLE_PAGE');

  return (
    <div className="flex flex-col items-center justify-center flex-1 h-full w-full text-center md:gap-3 gap-2 bg-white">
      <div className="pb-0.5"> </div>

      <h1 className="hidden md:block text-4xl text-content-neutral-main-enabled whitespace-pre-line">
        {t('NO_SURVEYS_FOR_NOW')}
      </h1>
      <h2 className="block md:hidden text-3xl text-content-neutral-main-enabled whitespace-pre-line pb-1 md:pb-0">
        {t('NO_SURVEYS_FOR_NOW')}
      </h2>

      <p className="text-body-p2 font-regular text-content-neutral-subtle-enabled whitespace-pre-line">
        {t('SUBTITLE')}
      </p>

      <Button label={t('BUTTON_TITLE')} mode={ButtonMode.OnLight} onClick={onClick} />
    </div>
  );
};

export default NoProjectsAvailablePage;
